module.exports = new __parcel__URL__("AutomationDiscoveryHeader.6db01409.svg").toString();